import React from 'react'

import {Text} from '@chakra-ui/react'
import {createPluginFactory, PlateRenderElementProps} from '@udecode/plate'

export const HeadingTwoRenderer = ({attributes, children}: PlateRenderElementProps) => {
  return (
    <Text as="h2" fontSize="30px" mb={2} {...attributes}>
      {children}
    </Text>
  )
}

export const createHeadingTwoPlugin = createPluginFactory({
  component: HeadingTwoRenderer,
  isElement: true,
  key: 'heading-two',
  type: 'heading-two',
})
